import { render, staticRenderFns } from "./SchoolSignupSuccessComponent.vue?vue&type=template&id=b0a064d2&"
import script from "./SchoolSignupSuccessComponent.vue?vue&type=script&lang=js&"
export * from "./SchoolSignupSuccessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports